import { render, staticRenderFns } from "./qualification-certificate-list.vue?vue&type=template&id=6e8dfdbe"
import script from "./qualification-certificate-list.vue?vue&type=script&lang=js"
export * from "./qualification-certificate-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports